import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// import "bootstrap-icons/font/bootstrap-icons.css";
// import "./bootstrap.css";
// import "./bootstrap.min.css";
// import "../src/material-kit.css";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <React.StrictMode>
    <BrowserRouter>
    <App />
    </BrowserRouter>
  </React.StrictMode>
  
);
